import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type PayoutCompletedToastProps = {
  toastId: string | number;
  creditorName: string;
  amount: string;
  transactionDate: string;
  onNavigate: () => void;
};

export const PayoutCompletedToast: FC<PayoutCompletedToastProps> = ({
  toastId,
  creditorName,
  amount,
  transactionDate,
  onNavigate
}) => {
  const {t} = useTranslation('payments');

  return (
    <ToastCard
      iconName="sollapay:check"
      title={t('payoutCompletedToast.title')}
      description={t('payoutCompletedToast.description', {creditorName, amount, transactionDate})}
      action={{label: t('payoutCompletedToast.actionLabel'), onClick: onNavigate}}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('payoutCompletedToast.close')}
    />
  );
};

export function showPayoutCompletedToast(
  creditorName: string,
  amount: string,
  transactionDate: string,
  onNavigate: () => void
): void {
  toast.custom(
    id => (
      <PayoutCompletedToast
        toastId={id}
        creditorName={creditorName}
        amount={amount}
        transactionDate={transactionDate}
        onNavigate={onNavigate}
      />
    ),
    {
      duration: 30_000
    }
  );
}
